// Позволяет вызывать SPA-навигацию (react-router) и диспатчить Redux-
// действия из кода, который не является React-компонентом и не может
// использовать useNavigate()/useDispatch() - например, из перехватчика
// axios в api.js. Обе функции регистрируются один раз корневым
// компонентом (см. App.jsx).
//
// Почему не импортировать store напрямую в api.js: он и его слайсы
// транзитивно импортируют сами api-команды (ans.js и т.п.), которые
// импортируют api.js - прямой импорт store создал бы циклическую
// зависимость (import-x/no-cycle). Этот модуль ничего не импортирует
// из store/api, поэтому цикл не возникает.
let navigateRef = null;
let dispatchRef = null;

export function setNavigate(navigate) {
  navigateRef = navigate;
}

export function setDispatch(dispatch) {
  dispatchRef = dispatch;
}

export function navigateTo(path, options) {
  if (navigateRef) {
    navigateRef(path, options);
    return;
  }
  // Подстраховка: если по какой-то причине navigate ещё не зарегистрирован
  // (например, ошибка случилась до первого рендера App) - жёсткий переход
  // всё же лучше, чем зависшее приложение без какого-либо перехода.
  window.location.href = path;
}

export function dispatchAction(action) {
  if (dispatchRef) {
    dispatchRef(action);
  }
  // Если dispatch ещё не зарегистрирован - тихо игнорируем: диспатчить
  // действие в несуществующий store всё равно было бы некуда.
}
